var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.data)?_c('div',{staticClass:"profile-families"},[(_vm.families.length > 0)?_c('div',{staticClass:"text-families",domProps:{"innerHTML":_vm._s(_vm.familiesText)}}):_vm._e(),(_vm.filteredSubFamilies.length > 0)?_c('div',{staticClass:"text-subfamilies",domProps:{"innerHTML":_vm._s(_vm.subFamiliesText)}}):_vm._e()]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }